// extracted by mini-css-extract-plugin
module.exports = {"CouponContainer":"Coupon_CouponContainer__2zfb2"};